import React, { useState, cloneElement, useEffect } from 'react';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';

export const VpPopover = ({
  onClick,
  id,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right'
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'right'
  },
  popoverContent,
  content,
  toggleCloseOverride
}) => {
  const popoverId = `${id}-popover`;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
    onClick && onClick();
  };
  const childrenProps = {
    onClick: handleClick,
    'aria-describedby': popoverId
  };

  useEffect(() => {
    setAnchorEl(null);
  }, [toggleCloseOverride]);

  return (
    <>
      {cloneElement(content, { ...childrenProps })}
      {popoverContent && (
        <Popover
          id={popoverId}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          {popoverContent}
        </Popover>
      )}
    </>
  );
};

VpPopover.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  popoverContent: PropTypes.node,
  content: PropTypes.node,
  toggleCloseOverride: PropTypes.bool,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string
  }),
  transformOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string
  })
};

export default VpPopover;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPopover/VpPopover.jsx